// Official @google/model-viewer UMD build (single script, no Shopify bundle .call issues)
const MODEL_VIEWER_UMD = 'https://cdn.jsdelivr.net/npm/@google/model-viewer@1.6.0/dist/model-viewer-umd.js';

function loadModelViewerScript() {
  if (customElements.get('model-viewer') !== undefined) return Promise.resolve();
  if (window.__modelViewerScriptLoadPromise) return window.__modelViewerScriptLoadPromise;
  window.__modelViewerScriptLoadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = MODEL_VIEWER_UMD;
    script.onload = () => {
      const deadline = Date.now() + 5000;
      const check = () => {
        if (customElements.get('model-viewer') !== undefined) {
          resolve();
          return;
        }
        if (Date.now() < deadline) setTimeout(check, 50);
        else resolve();
      };
      check();
    };
    script.onerror = () => reject(new Error('Failed to load model-viewer'));
    (document.head || document.documentElement).appendChild(script);
  });
  return window.__modelViewerScriptLoadPromise;
}

if (!customElements.get('product-model')) {
  class ProductModel extends HTMLElement {
    constructor() {
      super();
      this.jsonData = this.querySelector('[data-model-script]');
      if (this.jsonData && this.jsonData.textContent) {
        try {
          this.jsonData = JSON.parse(this.jsonData.textContent);
          this.jsonData = this.jsonData[0] || this.jsonData;
          
          // Validate JSON data structure
          if (!this.jsonData.sources || !Array.isArray(this.jsonData.sources) || this.jsonData.sources.length === 0) {
            console.error('Invalid model data: missing or empty sources array', this.jsonData);
          }
          if (!this.jsonData.preview_image || !this.jsonData.preview_image.src) {
            console.error('Invalid model data: missing preview_image', this.jsonData);
          }
        } catch (error) {
          console.error('Error parsing model JSON data:', error);
          this.jsonData = null;
        }
      } else {
        console.error('No model script data found');
        this.jsonData = null;
      }
    }
    connectedCallback() {
      this.loadModel();
      this.setupStructure();
      // Delay loadContent slightly to ensure DOM is ready for Shopify's auto-detection
      setTimeout(() => {
        this.loadContent();
      }, 50);
    }
    
    setupStructure(){
      if (!this.jsonData) {
        console.error('Cannot setup structure: invalid JSON data');
        return;
      }

      const placeholder = this.querySelector('[data-img-placeholder]');
      if (placeholder && this.jsonData.preview_image && this.jsonData.preview_image.src) {
        placeholder.src = this.jsonData.preview_image.src;
        if (this.jsonData.id) {
          placeholder.dataset.mediaId = this.jsonData.id;
        }
      }

      if(this.closest('.model-wrapper-container')?.querySelector('[data-shopify-xr]')) {
        this.closest('.model-wrapper-container').querySelector('[data-shopify-xr]').dataset.shopifyModel3dId = this.jsonData.id;
      }
      
      // Validate sources exist
      if (!this.jsonData.sources || !Array.isArray(this.jsonData.sources) || this.jsonData.sources.length === 0) {
        console.error('No model sources available', this.jsonData);
        return;
      }

      // Prefer GLB/glTF for model-viewer; USDZ is ZIP-based and causes "PK" is not valid JSON when parsed
      const glbSource = this.jsonData.sources.find(s =>
        (s.format && (s.format === 'glb' || s.format === 'gltf')) ||
        (s.mime_type && (s.mime_type === 'model/gltf-binary' || s.mime_type === 'model/gltf+json'))
      );
      const modelUrl = (glbSource && glbSource.url) ? glbSource.url : this.jsonData.sources[0].url;

      // Create model-viewer element directly in DOM (not in template) so Shopify can auto-detect it
      // Shopify auto-loads model-viewer when it detects data-shopify-feature="1.12" on a model-viewer element in the DOM
      const posterUrl = this.jsonData.preview_image?.src || '';
      const altText = this.jsonData.alt || '';
      
      const modelViewer = document.createElement('model-viewer');
      modelViewer.setAttribute('toggleable', 'true');
      modelViewer.setAttribute('src', modelUrl);
      modelViewer.setAttribute('camera-controls', 'true');
      modelViewer.setAttribute('style', '--poster-color: transparent; pointer-events: auto;');
      modelViewer.setAttribute('data-shopify-feature', '1.12');
      modelViewer.setAttribute('alt', altText);
      modelViewer.classList.add('model-viewer-no-swipe');
      if (posterUrl) {
        modelViewer.setAttribute('poster', posterUrl);
      }
      // Hide initially - will be shown when loaded
      modelViewer.style.display = 'none';
      
      // Store for deferred loading
      this.modelViewerElement = modelViewer;
      this.appendChild(modelViewer);
      
      // Stop pointer/touch/wheel from bubbling to Swiper so model-viewer gets rotate/zoom (Swiper noSwipingSelector doesn't see shadow DOM)
      this._boundStopPropagation = (e) => {
        const path = e.composedPath && e.composedPath();
        const isNode = (n) => n && typeof n.nodeType === 'number';
        const fromModelViewer = path ? path.some(n => {
          if (n === modelViewer) return true;
          if (!isNode(n)) return false;
          return modelViewer.shadowRoot && modelViewer.shadowRoot.contains(n);
        }) : (e.target && this.contains(e.target));
        if (fromModelViewer) {
          e.stopPropagation();
        }
      };
      const events = ['pointerdown', 'pointermove', 'pointerup', 'pointercancel', 'touchstart', 'touchmove', 'touchend', 'touchcancel', 'mousedown', 'mousemove', 'mouseup', 'wheel'];
      events.forEach(ev => this.addEventListener(ev, this._boundStopPropagation, { passive: true }));
    }

    loadModel() {
      // this.querySelector('[data-model-trigger]').addEventListener('click', this.loadContent.bind(this));
      const searchParams = new URLSearchParams(window.location.search);
      if (searchParams.get('ar-model') === 'true' && searchParams.get('modelID')) {
        window.ShopifyXR.launchXR({
          model3dId: searchParams.get('modelID'),
          title: globalVariables.product.title
        });
      }
    }

    loadDeferredContent(focus = true) {
      const slide = this.closest('.swiper-slide');
      const slideId = slide ? (slide.getAttribute('data-modal-id') || slide.getAttribute('data-model-slide-index') || '?') : 'page';
      const isActiveSlide = slide && slide.classList.contains('swiper-slide-active');
      // Only skip if we already ran show for this slide while it was active (so non-active slides never get loaded and will run full path when swiped to)
      if (this.getAttribute('loaded') && isActiveSlide) {
        return;
      }
      {
        // Use the model-viewer element we created in setupStructure
        const modelViewer = this.modelViewerElement || this.querySelector('model-viewer');
        
        if (!modelViewer) {
          console.error('model-viewer element not found');
          return;
        }
        
        // Check if model-viewer custom element is registered
        if (customElements.get('model-viewer') === undefined) {
          const showWhenReady = () => {
            if (customElements.get('model-viewer') === undefined) return false;
            modelViewer.style.display = '';
            modelViewer.style.pointerEvents = 'auto';
            modelViewer.classList.remove('shopify-model-viewer-ui__disabled');
            const productModel = this;
            if (productModel) productModel.style.pointerEvents = 'auto';
            const swiperSlide = this.closest('.swiper-slide');
            if (swiperSlide) swiperSlide.style.pointerEvents = 'none';
            if (swiperSlide && swiperSlide.classList.contains('swiper-slide-active')) {
              this.setAttribute('loaded', true);
              const currentSrc = modelViewer.getAttribute('src');
              if (currentSrc) {
                modelViewer.removeAttribute('src');
                modelViewer.setAttribute('src', currentSrc);
              }
            }
            const placeholder = this.querySelector('[data-img-placeholder]');
            if (placeholder) placeholder.style.display = 'none';
            if (focus && modelViewer) modelViewer.focus();
            return true;
          };

          // Give Shopify time to register first (avoids "name already used" when both load)
          const waitForShopify = 600;
          const start = Date.now();
          const pollOrLoad = () => {
            if (showWhenReady.call(this)) return;
            if (customElements.get('model-viewer') !== undefined) {
              showWhenReady.call(this);
              return;
            }
            if (Date.now() - start < waitForShopify) {
              setTimeout(pollOrLoad, 80);
              return;
            }
            // Still not registered after wait: load fallback (single UMD script)
            loadModelViewerScript()
              .then(() => { showWhenReady.call(this); })
              .catch(() => {})
              .finally(() => {
                const checkInterval = setInterval(() => {
                  if (showWhenReady.call(this)) clearInterval(checkInterval);
                }, 100);
                setTimeout(() => clearInterval(checkInterval), 10000);
              });
          };
          setTimeout(pollOrLoad, 80);
          return;
        }

        // Model-viewer is registered, show the element
        modelViewer.style.display = '';
        modelViewer.style.pointerEvents = 'auto';
        modelViewer.classList.remove('shopify-model-viewer-ui__disabled');
        // Force (re)load when this slide is active – model-viewer may not have loaded while hidden
        const swiperSlide = this.closest('.swiper-slide');
        if (swiperSlide && swiperSlide.classList.contains('swiper-slide-active')) {
          this.setAttribute('loaded', true);
          const currentSrc = modelViewer.getAttribute('src');
          if (currentSrc) {
            modelViewer.removeAttribute('src');
            modelViewer.setAttribute('src', currentSrc);
          }
        }
        if (swiperSlide) {
          swiperSlide.style.pointerEvents = 'none';
        }
        // Ensure parent elements allow pointer events
        const productModel = this;
        if (productModel) {
          productModel.style.pointerEvents = 'auto';
        }
        // Explicitly hide the placeholder image
        const placeholder = this.querySelector('[data-img-placeholder]');
        if (placeholder) {
          placeholder.style.display = 'none';
        }
        if (focus && modelViewer) {
          modelViewer.focus();
        }
      }
    }

    loadContent() {
      this.loadDeferredContent();

      // Ensure Shopify is available before loading features
      if (typeof Shopify === 'undefined') {
        console.error('Shopify object not available. Model viewer may not work.');
        // Try again after a short delay
        setTimeout(() => this.loadContent(), 100);
        return;
      }

      // Load model-viewer-ui (model-viewer should be auto-loaded by Shopify when it detects data-shopify-feature="1.12")
      // Wait a bit for Shopify to auto-detect and load model-viewer first
      const checkModelViewer = setInterval(() => {
        if (customElements.get('model-viewer') !== undefined) {
          clearInterval(checkModelViewer);
          Shopify.loadFeatures([
            {
              name: 'model-viewer-ui',
              version: '1.0',
              onLoad: this.setupModelViewerUI.bind(this),
            },
          ]);
        }
      }, 100);
      
      // Timeout after 5 seconds - if model-viewer isn't loaded, try loading model-viewer-ui anyway
      setTimeout(() => {
        clearInterval(checkModelViewer);
        // Load model-viewer-ui regardless (it might help trigger model-viewer loading)
        Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);
      }, 5000);
    }

    setupModelViewerUI(errors) {
      if (errors) {
        console.error('Error loading model-viewer-ui:', errors);
        return;
      }

      const modelViewer = this.querySelector('model-viewer');
      if (!modelViewer) {
        console.error('model-viewer element not found');
        return;
      }

      if (typeof Shopify.ModelViewerUI === 'undefined') {
        console.error('Shopify.ModelViewerUI not available');
        return;
      }

      try {
        this.modelViewerUI = new Shopify.ModelViewerUI(modelViewer);
        // Shopify adds shopify-model-viewer-ui__disabled which blocks rotate/zoom; remove and keep it off
        const ensureModelViewerEnabled = () => {
          if (modelViewer.classList.contains('shopify-model-viewer-ui__disabled')) {
            modelViewer.classList.remove('shopify-model-viewer-ui__disabled');
          }
        };
        const scheduleRemoveDisabled = () => {
          ensureModelViewerEnabled();
          requestAnimationFrame(ensureModelViewerEnabled);
          setTimeout(ensureModelViewerEnabled, 0);
          setTimeout(ensureModelViewerEnabled, 50);
          setTimeout(ensureModelViewerEnabled, 150);
        };
        ensureModelViewerEnabled();
        this._disabledObserver = new MutationObserver(scheduleRemoveDisabled);
        this._disabledObserver.observe(modelViewer, { attributes: true, attributeFilter: ['class'] });
      } catch (error) {
        console.error('Error initializing ModelViewerUI:', error);
      }
    }
  }
  customElements.define('product-model',ProductModel);
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR());
      return;
    }

    let threeDJsons = [];
    document.querySelectorAll('[data-model-script]').forEach((modelJSON) => {
      threeDJsons.push(JSON.parse(modelJSON.textContent));
    });
    setTimeout(() => {
      window.ShopifyXR.addModels(threeDJsons);
      window.ShopifyXR.setupXRElements();
    }, 100);
  }
};

window.addEventListener('load', async () => {
  if (window.ProductModel) await window.ProductModel.loadShopifyXR();
  const searchParams = new URLSearchParams(window.location.search);
  const urlModelID = searchParams.get('modelID');
  const arModel = searchParams.get('ar-model') === 'true';

  // When landing from QR (ar-model=true&modelID=X): set variant and "View in your space" to that model
  if (arModel && urlModelID) {
    const slide = document.querySelector(`[data-modal-slider] .swiper-slide[data-modal-id="${urlModelID}"]`);
    const variantIdsRaw = slide?.getAttribute('data-variant-ids');
    if (variantIdsRaw && typeof globalVariables !== 'undefined' && globalVariables?.product) {
      const firstVariantId = variantIdsRaw.split(',')[0].trim();
      const variantSelects = document.querySelector('variant-selects[data-type*="variant-radios"], variant-selects[data-type*="variant-radio"]');
      if (variantSelects && typeof variantSelects.setVariantById === 'function' && firstVariantId) {
        variantSelects.setVariantById(firstVariantId);
      }
    }
    // Ensure all "View in your space" openers use the model from the URL so AR/modal show correct model
    document.querySelectorAll('[data-modal-opener="ProductPopup-space"][data-shopify-model3d-id]').forEach((el) => {
      el.setAttribute('data-shopify-model3d-id', urlModelID);
    });
    // Preserve ar-model and modelID in URL (variant is set by variant-selects.replaceState)
    const baseUrl = window.location.pathname;
    const variantSelects = document.querySelector('variant-selects');
    const currentVariantId = variantSelects?.currentVariant?.id || (() => {
      const input = document.querySelector('form[data-format="product-page"] input[name="id"]');
      return input?.value;
    })();
    const params = new URLSearchParams();
    if (currentVariantId) params.set('variant', String(currentVariantId));
    params.set('ar-model', 'true');
    params.set('modelID', urlModelID);
    window.history.replaceState({}, '', `${baseUrl}?${params.toString()}`);

    // Auto-launch AR only when landing from QR (ar-model=true&modelID in URL); wait for ShopifyXR to be ready
    const tryLaunchAR = () => {
      if (!window.ShopifyXR || !urlModelID) return;
      try {
        window.ShopifyXR.launchXR({
          model3dId: urlModelID,
          title: typeof globalVariables !== 'undefined' && globalVariables?.product?.title ? globalVariables.product.title : document.title
        });
      } catch (e) {
        // AR may not be available (e.g. device/browser); user can still tap "View in your space"
      }
    };
    setTimeout(tryLaunchAR, 400);
    setTimeout(tryLaunchAR, 1200);
  }
});